import { render, staticRenderFns } from "./PartsSummary.vue?vue&type=template&id=2ad0fdb8&scoped=true"
import script from "./PartsSummary.vue?vue&type=script&lang=ts"
export * from "./PartsSummary.vue?vue&type=script&lang=ts"
import style0 from "./PartsSummary.vue?vue&type=style&index=0&id=2ad0fdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0fdb8",
  null
  
)

export default component.exports